import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const UPDATE_MATRIX_ROW = questionnaireGql(/* GraphQL */ `
  mutation updateMatrixRowV2($input: UpdateMatrixRowV2Input!) {
    updateMatrixRowV2(input: $input) {
      ...DraftMatrixRow
    }
  }
`)
